export default "__VITE_ASSET__8949aabc__"